import { CommonModule } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";

interface Testimonial {
  title: string;
  company: string;
  text: string;
  initials: string;
}

@Component({
  selector: "app-home-testimonials-2",
  templateUrl: "./home-testimonials-2.component.html",
  styleUrls: ["./home-testimonials-2.component.scss"],
  standalone: true,
  imports: [CommonModule, TranslateModule],
})
export class HomeTestimonials2Component implements OnInit {
  constructor() {}

  ngOnInit(): void {}

  testimonials: Testimonial[] = [
    {
      title: "Michael Von den Benken",
      company: "Director at DUNI AB, Sweden",
      text: `CDC's collective approach gave us significantly increased negotiating power against the cartelists, making the whole process far more effective.`,
      initials: "MB",
    },
    {
      title: "Teemu Taxell",
      company: "Partner at Merilampi Law Firm, Finland",
      text: `Pursuing cartel damages actions through CDC proved to be the most effective solution, combining legal expertise with a results-driven approach.`,
      initials: "TT",
    },
    {
      title: "José Moutas",
      company: "Chief Legal Counsel at ENCE Energia y Celulosa SA, Spain",
      text: `Having successfully achieved several significant settlements, CDC ensures that victims are properly compensated for their loss with minimal effort on our part.`,
      initials: "JM",
    },
    {
      title: "Jan Geier",
      company: "Steinbeis Papier GmbH, Germany",
      text: `CDC has won five settlements on our behalf. The entire process was handled professionally, with all costs entirely borne by CDC.`,
      initials: "JG",
    },
  ];
}
